import { render, staticRenderFns } from "./RefundRequests.vue?vue&type=template&id=d772bcc6&scoped=true&"
import script from "./RefundRequests.vue?vue&type=script&lang=js&"
export * from "./RefundRequests.vue?vue&type=script&lang=js&"
import style0 from "./RefundRequests.vue?vue&type=style&index=0&id=d772bcc6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d772bcc6",
  null
  
)

export default component.exports